import type { BlogPost } from "@/types/blog";

const BLOG_COVER_BY_SLUG: Record<string, string> = {
  "guia-completo-de-fotografia-imobiliaria-em-balneario-camboriu": 
    "/images/blog/fotografia-imobiliaria.svg",
  "video-imobiliario-a-ferramenta-essencial-para-vendas-em-itajai":
    "/images/blog/video-imobiliario.svg",
  "marketing-digital-imobiliario-estrategias-vencedoras":
    "/images/blog/marketing-imobiliario.svg",
  "10-erros-fatais-em-fotografia-de-imoveis-que-voce-deve-evitar":
    "/images/blog/erros-fotografia.svg",
  "crm-imobiliario-como-aumentar-vendas-em-itajai-com-gestao-de-relacionamento":
    "/images/blog/crm-imobiliario.svg",
};

const BLOG_COVER_BY_CATEGORY: Record<string, string> = {
  "Fotografia Imobiliária": "/images/blog/fotografia-imobiliaria.svg",
  "Marketing Digital Imobiliário": "/images/blog/marketing-imobiliario.svg",
  "Mercado Imobiliário": "/images/blog/marketing-imobiliario.svg",
  "Tecnologia e IA": "/images/blog/crm-imobiliario.svg",
  "Técnicas de Vendas": "/images/blog/video-imobiliario.svg",
  "CRM Imobiliário": "/images/blog/crm-imobiliario.svg",
  "Educação Toc Toc": "/images/blog/blog-default.svg",
  "Tendências & Growth": "/images/blog/marketing-imobiliario.svg",
};

export const DEFAULT_BLOG_COVER = "/images/blog/blog-default.svg";

export const getBlogCoverImage = (post?: Pick<BlogPost, "slug" | "category" | "cover_url" | "featured_image">) => {
  if (!post) {
    return DEFAULT_BLOG_COVER;
  }

  const fromPost = post.cover_url?.trim() || post.featured_image?.trim();
  if (fromPost) {
    return fromPost;
  }

  const fromSlug = post.slug ? BLOG_COVER_BY_SLUG[post.slug] : undefined;
  if (fromSlug) {
    return fromSlug;
  }

  const categoryKey = post.category?.trim();
  if (categoryKey) {
    const fromCategory = BLOG_COVER_BY_CATEGORY[categoryKey];
    if (fromCategory) {
      return fromCategory;
    }
  }

  return DEFAULT_BLOG_COVER;
};

export const blogIllustrations = {
  DEFAULT_BLOG_COVER,
  ...BLOG_COVER_BY_SLUG,
  ...BLOG_COVER_BY_CATEGORY,
};
